import { Header, type HeaderCrumb } from "@exopengithub/exokit";
import type { ReactNode } from "react";

export type HeaderLayoutRenderLink = (props: {
	href: string;
	children: ReactNode;
}) => ReactNode;

export type HeaderLayoutViewProps = {
	breadcrumbs: HeaderCrumb[];
	title: string;
	tabs?: ReactNode;
	search?: ReactNode;
	actions?: ReactNode;
	/** Renders a breadcrumb's href — the caller owns routing. */
	renderLink: HeaderLayoutRenderLink;
	children: ReactNode;
};

/**
 * Standard page chrome: a breadcrumb trail + page title (ExoKit Header) over
 * the page content, full-bleed per the Figma. The header is never capped —
 * a page that wants a narrow column caps its own content. Portable — the
 * breadcrumb trail and link rendering come from the caller.
 */
export const HeaderLayoutView = ({
	breadcrumbs,
	title,
	tabs,
	search,
	actions,
	renderLink,
	children,
}: HeaderLayoutViewProps) => {
	return (
		<div className="p-4 md:p-6">
			<Header
				breadcrumbs={breadcrumbs}
				title={title}
				tabs={tabs}
				search={search}
				actions={actions}
				renderLink={renderLink}
			/>
			<div className="mt-6">{children}</div>
		</div>
	);
};
